/**
 * Convocations et documents officiels (TODO phase 17, ADR-034).
 * Chaque document officiel porte un CODE DE VÉRIFICATION (12 caractères de
 * l'alphabet des matricules) et un QR code menant à la page publique de
 * vérification, qui n'affiche que l'authenticité et des données minimales.
 */
import { MATRICULE_ALPHABET } from './matricules.js';
/** Récépissé : 10 caractères (`submission_ref`) ; documents officiels : 12. */
export const VERIFICATION_CODE_LENGTH = 12;
export const VERIFICATION_CODE_REGEX = new RegExp(`^[${MATRICULE_ALPHABET}]{${VERIFICATION_CODE_LENGTH}}$`);
export const OFFICIAL_DOCUMENT_KINDS = {
    convocation: 'Convocation',
    convocation_list: 'Liste des convoqués',
    summary: 'Fiche récapitulative de candidature',
    grade_sheet: 'Relevé de notes',
    commission_report: 'Procès-verbal de commission',
    results_list: 'Liste des résultats',
};
/** Version des modèles d'impression : figée dans chaque document produit. */
export const DOCUMENT_TEMPLATES = {
    convocation: 'convocation@1',
    convocation_list: 'liste-convoques@1',
    summary: 'fiche-recapitulative@1',
    grade_sheet: 'releve-notes@1',
    commission_report: 'pv-commission@1',
    results_list: 'liste-resultats@1',
};
export const CONVOCATION_STATUSES = {
    draft: 'Préparée',
    issued: 'Envoyée',
    cancelled: 'Annulée',
};
export const DISTRIBUTION_MODES = {
    alphabetical: 'Ordre alphabétique',
    application: 'Ordre des matricules',
    lot: 'Par lot de correction, puis ordre alphabétique',
};
export const BATCH_STATUSES = {
    queued: 'En attente',
    running: 'En cours',
    done: 'Terminé',
    failed: 'Échec',
};
/** Variables utilisables dans le modèle de convocation d'une étape. */
export const CONVOCATION_VARIABLES = [
    'nom',
    'matricule',
    'date',
    'centre',
    'salle',
    'place',
];
/** Remplace `{variable}` ; une variable inconnue est laissée telle quelle (visible à l'aperçu). */
export function fillTemplate(template, values) {
    return template.replace(/\{([a-z]+)\}/g, (match, key) => key in values && values[key] !== undefined
        ? values[key]
        : match);
}
/**
 * Répartition des candidats dans les salles, dans l'ordre fourni : chaque
 * salle est remplie jusqu'à sa capacité, places numérotées à partir de 1.
 * `null` si la capacité totale est insuffisante (jamais de surnombre).
 */
export function distributeSeats(candidateIds, rooms) {
    const capacity = rooms.reduce((n, r) => n + Math.max(0, r.capacity), 0);
    if (capacity < candidateIds.length)
        return null;
    const seats = [];
    let index = 0;
    for (const room of rooms) {
        for (let seat = 1; seat <= room.capacity && index < candidateIds.length; seat++)
            seats.push({ candidateId: candidateIds[index++], roomId: room.roomId, seat });
        if (index >= candidateIds.length)
            break;
    }
    return seats;
}
//# sourceMappingURL=official_documents.js.map